import { defineComponent as d, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "0041fd51-c98c-4770-a555-6e3327aa6796" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#0041fd51-c98c-4770-a555-6e3327aa6796)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#eee" d="m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z"></path><path fill="#d80027" d="M0 0h512v144.7H0z"></path><path fill="#0052b4" d="M0 367.3h512V512H0z"></path><path fill="#6da544" d="m319 182-23.6 23.5a55.5 55.5 0 0 1-39.4 95 55.7 55.7 0 0 1-39.3-95L193 182a89 89 0 1 0 126 0z"></path><path fill="#ffda44" d="m256 211.5 8.3 25.5H291l-21.7 15.8 8.3 25.5-21.7-15.8-21.7 15.8 8.3-25.5-21.7-15.8h26.8z"></path>', 5), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "py",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, a = o(() => 512 + 2 * e.strokeWidth), l = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${l.value} ${l.value} ${a.value} ${a.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (s(), i("title", u, n(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=py-8bfd8fcc.js.map
